import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  AdminProductBody,
  AdminProductCategory,
  AdminProductDetail,
  AdminProductImages,
  AdminProductPage,
  AdminProductParams,
  AdminProductSummary,
} from '../types/adminProduct.types';

export const fetchAdminProductSummary = async (): Promise<AdminProductSummary> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminProductSummary}`);
};

export const fetchAdminProducts = async (params: AdminProductParams): Promise<AdminProductPage> => {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.size) query.set('size', String(params.size));
  if (params.status) query.set('status', params.status);
  if (params.q) query.set('q', params.q);
  return await request.get(`${URLS.BACK_DSH}${APIS.adminProducts(query.toString())}`);
};

export const fetchAdminProductCategories = async (): Promise<{ rows: AdminProductCategory[] }> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminProductCategories}`);
};

export const fetchAdminProduct = async (productId: string): Promise<AdminProductDetail> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminProduct(productId)}`);
};

/** A new book; SKU and slug are generated. Photos are uploaded afterwards. */
export const createAdminProduct = async (body: AdminProductBody): Promise<AdminProductDetail> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.adminProductCreate}`, body);
};

export const updateAdminProduct = async (
  productId: string,
  body: AdminProductBody
): Promise<AdminProductDetail> => {
  return await request.put(`${URLS.BACK_DSH}${APIS.adminProduct(productId)}`, body);
};

/** Soft delete; 422 while the book is part of a bundle. */
export const deleteAdminProduct = async (productId: string) => {
  return await request.delete(`${URLS.BACK_DSH}${APIS.adminProduct(productId)}`);
};

/** JPEG, PNG or WebP, 5 MB each, 35 per product; new photos go last. */
export const uploadAdminProductImages = async (
  productId: string,
  files: File[]
): Promise<AdminProductImages> => {
  const form = new FormData();
  for (const file of files) form.append('files', file);
  return await request.post(`${URLS.BACK_DSH}${APIS.adminProductImages(productId)}`, form);
};

export const deleteAdminProductImage = async (
  productId: string,
  imageId: string
): Promise<AdminProductImages> => {
  return await request.delete(`${URLS.BACK_DSH}${APIS.adminProductImage(productId, imageId)}`);
};
